<template>
  <c-form
    class="resend-verification"
    @submit.prevent="submit"
  >

    <c-form-input
      id="email"
      ref="input"
      :errors="[{
        message: 'Dieses Feld ist erforderlich.',
        show: !$v.email.required
      }, {
        message: 'Keine gültige E-Mail-Adresse.',
        show: !$v.email.email
      }]"
      :has-error="$v.email.$error"
      v-model="email"
      aria-required="true"
      autocomplete="username"
      label="E-Mail-Adresse"
      type="email"
    />

    <c-button :busy="status === $config.status.SAVING">
      Neuen Link anfordern
    </c-button>

  </c-form>
</template>

<script>
import CForm from '@/components/form/CForm'
import CButton from '@/components/CButton'
import CFormInput from '@/components/form/CFormInput'

import { required, email } from 'vuelidate/lib/validators'

import handleRequestError from '@/functions/handleRequestError'

export default {
  name: 'CResendVerification',

  components: {
    CForm,
    CButton,
    CFormInput
  },

  validations: {
    email: {
      required,
      email
    }
  },

  data () {
    return {
      email: '',
      status: this.$config.status.IDLE
    }
  },

  methods: {
    submit () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$store.commit('notifications/add', {
          type: 'error',
          text: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.'
        })

        return
      }

      this.status = this.$config.status.SAVING

      this.$api.post('auth/resend-verification/', {
        email: this.email
      })
        .then(response => {
          this.$store.commit('notifications/add', {
            type: 'success',
            text: 'Eine neue E-Mail wurde versendet. Bitte folgen Sie dem Bestätigungslink in der Nachricht.'
          })

          this.$router.push({ name: 'login' })
        })
        .catch(error => {
          handleRequestError({
            error,
            fallback: 'Beim Versenden der E-Mail gab es ein Problem. Bitte versuchen Sie es später erneut.'
          })

          this.status = this.$config.status.ERROR
        })
    }
  }
}
</script>

<style scoped>
.resend-verification {
  margin-bottom: var(--grid-spacing);
}
</style>
